import Vue from 'vue';
import Page from './Page.vue';

(new Vue({
  render(h) {
    return h(Page);
  },
})).$mount('#app');
